// extracted by mini-css-extract-plugin
module.exports = {"noData":"_cbc56cc","noDataButtons":"_0ec5c06"};